export const getDomicilioFiscalModel = () => ({
    txtPais: {
        name: "txtPais",
        label: "País:",
        value: null,
        required: true,
        error: false,
        helper: "Selecciones el país",
    },
    txtEstado: {
        name: "txtEstado",
        label: "Estado:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha capturado el estado",
    },
    txtMunicipio: {
        name: "txtMunicipio",
        label: "Municipio:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha capturado el municipio",
    },
    txtCiudad: {
        name: "txtCiudad",
        label: "Ciudad:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha capturado la ciudad",
    },
    txtCodigoPostal: {
        name: "txtCodigoPostal",
        label: "Código postal:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese el código postal",
    },
    txtColonia: {
        name: "txtColonia",
        label: "Colonia:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha capturado la colonia",
    },
    txtOtraColonia: {
        name: "txtOtraColonia",
        label: "Especifique otra colonia:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha capturado la colonia",
    },
    txtCalle: {
        name: "txtCalle",
        label: "Calle:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese la calle",
    },
    txtNumeroExterior: {
        name: "txtNumeroExterior",
        label: "Número Exterior:",
        value: "",
        required: false,
        error: false,
        helper: "Ingrese el número exterior",
    },
    txtNumeroInterior: {
        name: "txtNumeroInterior",
        label: "Número interior:",
        value: "",
        required: false,
        error: false,
        helper: "Ingrese el número interior",
    },
});
